/**
 * Utility functions for attack path name/ID conversion.
 *
 * Attack paths are stored as files with IDs prefixed with "attack-path-".
 * These utilities convert between the display name and the storage ID.
 */

/** Prefix for attack path file names in storage */
const ATTACK_PATH_PREFIX = 'attack-path-';

/**
 * Extract the display name from an attack path file ID.
 * @param fileId - The full file ID (e.g., "attack-path-ABCDE")
 * @returns The display name (e.g., "ABCDE")
 */
export function getAttackPathNameFromId(fileId: string): string {
  return fileId.replace(ATTACK_PATH_PREFIX, '');
}

/**
 * Convert a display name to an attack path file ID.
 * @param name - The display name (e.g., "ABCDE")
 * @returns The file ID (e.g., "attack-path-ABCDE")
 */
export function getAttackPathIdFromName(name: string): string {
  return `${ATTACK_PATH_PREFIX}${name}`;
}
